import { Component, OnInit } from "@angular/core";
// import  {AwsRumConfig, AwsRum}  from "aws-rum-web";

declare global {
  interface Navigator {
    msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void;
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit{
  title = "iforms";

  ngOnInit(){
    try {
      // const config: AwsRumConfig = {
      //   sessionSampleRate: 1,
      //   guestRoleArn: "arn:aws:iam::735360830536:role/RUM-Monitor-us-east-1-735360830536-5270197451761-Unauth",
      //   identityPoolId: "us-east-1:980b1fe1-4672-4eeb-aeaa-775d3e35623e",
      //   endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      //   telemetries: ["performance","errors","http"],
      //   allowCookies: true,
      //   enableXRay: false
      // };
    
      const APPLICATION_ID: string = '2bf30fdf-579a-4f42-854b-ea6ca610d8fe';
      const APPLICATION_VERSION: string = '1.0.0';
      const APPLICATION_REGION: string = 'us-east-1';
    
      // const awsRum: AwsRum = new AwsRum(
      //   APPLICATION_ID,
      //   APPLICATION_VERSION,
      //   APPLICATION_REGION,
      //   config
      // );
    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
    
  }

}
